import type { FC } from 'react'

import { twMerge } from 'tailwind-merge'

import { useAppContext } from '@/App.context'

import { lightSuccessBgStyleByWhiteLabel } from '../util/style-constant'

import { BuyOutOfferingContent } from './BuyOutOfferingContent'
import { BuyOutOfferingStatus } from './BuyOutOfferingStatus'
import type { BuyoutOffering } from './types'

type BuyoutOfferingProps = {
  data: BuyoutOffering
}

export const BuyOutOffering: FC<BuyoutOfferingProps> = ({ data }) => {
  const { whiteLabel } = useAppContext()

  const isRejectedOrExpired = data.status === 'REJECTED' || data.status === 'EXPIRED'
  const isAccepted = data.status === 'ACCEPTED'

  const lightSuccessBgColor =
    lightSuccessBgStyleByWhiteLabel[whiteLabel] || lightSuccessBgStyleByWhiteLabel.skytech

  return (
    <div
      className={twMerge(
        'group border-0 border-t-2 border-solid border-gray-200 px-4 py-3 shadow-md',
        isRejectedOrExpired && 'relative bg-gray-100 opacity-60',
        !isRejectedOrExpired && isAccepted
          ? `relative ${lightSuccessBgColor} opacity-80`
          : 'bg-white'
      )}
    >
      {isAccepted || isRejectedOrExpired ? (
        <BuyOutOfferingStatus data={data} />
      ) : (
        <BuyOutOfferingContent data={data} />
      )}
    </div>
  )
}
